import {observable, action, runInAction} from 'mobx'
import {json} from '../../../utils/ajax'
import {handleSearchAndPage, ValueObjToObj, objToValueObj, setStore} from "../../../utils/Utils";
import {message} from 'antd'

class SystemDictionary {
    @observable loading         //系统列表数据loading
    @observable dictionaryList  //系统列表数据
    @observable pagination      //分页
    @observable searchFields    //搜索值绑定
    @observable modalVisible    //控制模态框显示属性
    @observable editFields      //模态框表单值绑定
    @observable option         //模态框状态参数 新增/修改 addSame/edit/addChild/一级是不传入
    @observable confirmLoading         //模态框确认loading
    @observable modalTitle  //模态框名

    constructor() {
        this.loading = false
        this.dictionaryList = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchFields = {
            name: '',
        }
        this.modalVisible = false
        this.option = ''
        this.editFields = {
            name: {},
            code: {},
            enName: {}
        }
        this.confirmLoading = false
        this.modalTitle = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**初始化页面*yg**/
    @action
    initDictionaryPage = async (page) => {
        this.loading = true
        let searchResult = handleSearchAndPage(page, this.pagination, this.searchFields)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/queryPage:search`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.dictionaryList = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements?res.totalElements:0} 条`
            }
            this.loading = false
        })
    }

    /*** 绑定主页面搜索框值****/
    @action
    onFormField = (changeFields, fields) => {
        const change = ValueObjToObj(changeFields)
        this[fields] = {...this[fields], ...change}
    }

    /***绑定新增、编辑表单值，回显验证规则**/
    @action
    onFormDisplayValue = (changeFields, fields) => {
        this[fields] = {...this[fields], ...changeFields}
    }

    /**清空搜索**/
    @action
    searchReset = () => {
        this.searchFields = {
            name: ''
        }
        this.initDictionaryPage()
    }

    /**根据传入参数弹出模块框,编辑或新增*/
    @action
    isShowModal = (record, option) => {
        this.confirmLoading = false
        this.info = record
        this.option = option
        if (option === 'edit') {
            this.editFields = objToValueObj(record)
        } else {
            this.editFields = {}
        }
        this.modalVisible = true
    }

    /***根据选项参数保存相应MODAL**/
    @action
    openOptionModal = async (content) => {
        let result = content
        this.confirmLoading = true
        if (this.option === 'edit') {
            result.id = this.info.id
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/update`, result)
            runInAction(() => {
                this.confirmLoading = false
            })
            message.success('修改成功')
        } else {
            if (this.option === 'addSame') {            //新增同级
                result.level = this.info.level
                result.pId = this.info.pId
            } else if (this.option === 'addChild') {        //新增下级
                result.level = this.info.level + 1
                result.pId = this.info.id
            } else {                     //新增一级
                result.level = 1
                result.pId = 0
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/add`, result)
            if (res.status !== 0) {
                runInAction(() => {
                    this.confirmLoading = false
                })
                message.success('新增成功')
            }
        }
        runInAction((() => {
            this.modalVisible = false
            this.initDictionaryPage()
        }))
    }

    /**删除**/
    @action
    delete = async (id) => {
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/delete/${id}`)
        runInAction(() => {
            this.initDictionaryPage()
            message.success('删除成功')
        })
    }

}

export default new SystemDictionary()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/SystemDictionary/store.js